"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (message) {
  console.warn("[Vue-noCAPTCHA] " + message);
};